import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./lib/auth";
import Login from "./screens/Login";
import TeacherHome from "./screens/TeacherHome";
import EntryGrid from "./screens/EntryGrid";
import StudentView from "./screens/StudentView";
import ParentView from "./screens/ParentView";
import Admin from "./screens/Admin";
function Guard({ children, allow }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading)
        return _jsx("div", { className: "p-10 text-center text-slate2 text-sm", children: "Loading\u2026" });
    if (!user)
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: loc.pathname } });
    if (allow && !allow.includes(user.role))
        return _jsx(Navigate, { to: "/", replace: true });
    return children;
}
function RoleHome() {
    const { user, loading } = useAuth();
    if (loading)
        return null;
    if (!user)
        return _jsx(Navigate, { to: "/login", replace: true });
    switch (user.role) {
        case "admin": return _jsx(Navigate, { to: "/admin", replace: true });
        case "teacher": return _jsx(Navigate, { to: "/teacher", replace: true });
        case "student": return _jsx(Navigate, { to: "/me", replace: true });
        case "parent": return _jsx(Navigate, { to: "/parent", replace: true });
    }
}
export default function App() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsx(Route, { path: "/", element: _jsx(RoleHome, {}) }), _jsx(Route, { path: "/teacher", element: _jsx(Guard, { allow: ["teacher", "admin"], children: _jsx(TeacherHome, {}) }) }), _jsx(Route, { path: "/teacher/class/:classId/exam/:examId", element: _jsx(Guard, { allow: ["teacher", "admin"], children: _jsx(EntryGrid, {}) }) }), _jsx(Route, { path: "/me", element: _jsx(Guard, { allow: ["student"], children: _jsx(StudentView, {}) }) }), _jsx(Route, { path: "/parent", element: _jsx(Guard, { allow: ["parent"], children: _jsx(ParentView, {}) }) }), _jsx(Route, { path: "/admin/*", element: _jsx(Guard, { allow: ["admin"], children: _jsx(Admin, {}) }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }));
}
